import IndustryChecklistI18n from "@/components/landing/shared/IndustryChecklistI18n";
const ChecklistVersicherungSection = () => <IndustryChecklistI18n translationPrefix="industryVersicherung" />;
export default ChecklistVersicherungSection;
